module.exports = __webpack_public_path__ + "static/6318-c96a0bf0667f224f996ffc999170e1f3.png";